import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ISubNavPage} from '@shared/core/components/subNav';

@Component({
    selector: 'shared-sub-nav-label-for-mobile',
    templateUrl: './sub-nav-label-for-mobile.shared.component.html',
    styleUrls: ['./sub-nav-label-for-mobile.shared.component.scss']
})
export class SubNavLabelForMobileComponent implements OnChanges {
    @Input() public active: number;
    @Input() public pages!: ISubNavPage[];
    public activeLabel: string;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.pages && changes.pages?.previousValue !== this.pages && this.pages) {
            this._findLabel();
        }

        if (changes.active && changes.active?.previousValue !== this.active && this.active) {
            this._findLabel();
        }
    }

    private _findLabel(): void {
        this.activeLabel = this.pages?.filter((page: ISubNavPage) => page?.Id === this.active)[0]?.Name;
    }
}
